'use strict';

var react = require('@chakra-ui/react');

const ChevronLeftIcon = react.createIcon({
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z",
  displayName: "ChevronLeftIcon"
});

exports.ChevronLeftIcon = ChevronLeftIcon;
